export enum TableColumnHeaderDisplayType {
	raw = 'raw',
	scaleLegend = 'scaleLegend',
	weightingBar = 'weightingBar',
}
